import { Input, InputGroup, InputLeftElement } from "@chakra-ui/react";
import { SearchIcon } from "@icons";

import { useColor } from "@/styles/useColor";

type NetworkSelectorSearchBarProps = {
  onChange: (input: string) => void;
};

export const NetworkSelectorSearchBar = ({ onChange }: NetworkSelectorSearchBarProps) => {
  const color = useColor();

  return (
    <InputGroup border="1px solid white" borderColor={color("300")} borderRadius="full">
      <InputLeftElement marginLeft="12px" pointerEvents="none">
        <SearchIcon color={color("400")} aria-label="Search network" />
      </InputLeftElement>
      <Input
        marginLeft="24px"
        border="0px"
        borderRadius="full"
        aria-label="Search networks"
        data-testid="network-search-input"
        id="network-search"
        onChange={e => onChange(e.target.value.toLowerCase())}
        placeholder="Search..."
        type="text"
      />
    </InputGroup>
  );
};
